import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldText(props) {
  const { field, action, value, handleChange, hasChanged, inputAttribute } = props
  console.log(`AppObjectFieldText rendered: ${field.name}`, props)

  if (isDisabled(action, field.behaviorType)) {
    return (<span>{value}</span>)
  }
  return (
    <Input
      valid={inputAttribute === 'valid'}
      invalid={inputAttribute === 'invalid'}
      type="text"
      bsSize="sm"
      name={field.id}
      className="app-object-field-text"
      id={field.id}
      value={value}
      onChange={(event) => handleChange(event, hasChanged)}
      size={field.width.toString()}
      data-cy={`field-${field.id}`}
    />
  )
}
